export var storageType = {
  session: sessionStorage,
  local: localStorage
};
export function setItem(key, data) {
  var storage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : storageType.session;
  storage.setItem(key, JSON.stringify(data || ''));
  return Promise.resolve();
}
export function getItem(key) {
  var storage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : storageType.session;
  return new Promise(function (resolve, reject) {
    try {
      var item = storage.getItem(key);
      resolve(item ? JSON.parse(item) : undefined);
    } catch (error) {
      reject(error);
    }
  });
}
export function removeItem(key) {
  var storage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : storageType.session;
  storage.removeItem(key);
  return Promise.resolve();
}